import DashboardPage from './pages/DashboardPage'

const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardPage
  }
]

export default routes